import { render, staticRenderFns } from "./TermsAndConditionsAdvice.vue?vue&type=template&id=405a5d6e&scoped=true&"
var script = {}
import style0 from "./TermsAndConditionsAdvice.vue?vue&type=style&index=0&id=405a5d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a5d6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
